export default __webpack_public_path__ + "static/101213-c5147353d957dcd5c7439c7994b74477.jpg";